import { render, staticRenderFns } from "./StatisticsHomepage.vue?vue&type=template&id=73e16b2a&"
import script from "./StatisticsHomepage.vue?vue&type=script&lang=js&"
export * from "./StatisticsHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports